import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationsBG from './i18n/bg/translations.json';
import translationsEN from './i18n/en/translations.json';

const resources = {
  bg: {
    translation: translationsBG
  },
  en: {
    translation: translationsEN
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'bg',
    fallbackLng: 'bg',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;

